//=============================
// CORE ACTION TYPES
//=============================
export const INIT_AUTH = 'INIT_AUTH';

export const SIGN_IN_ERROR = 'SIGN_IN_ERROR';
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS';

export const SIGN_OUT_SUCCESS = 'SIGN_OUT_SUCCESS';

//=============================
// SIDE EFFECT ACTION TYPES
//=============================
export const AUTH_LOAD_STUDENT_RECORD_SUCCESS = 'AUTH_LOAD_STUDENT_RECORD_SUCCESS'
export const AUTH_LOAD_STUDENT_RECORD_FAILURE = 'AUTH_LOAD_STUDENT_RECORD_FAILURE'

export const AUTH_CREATE_STUDENT_RECORD_SUCCESS = 'AUTH_CREATE_STUDENT_RECORD_SUCCESS'
export const AUTH_CREATE_STUDENT_RECORD_FAILURE = 'AUTH_CREATE_STUDENT_RECORD_FAILURE'


// WEBPACK FOOTER //
// ./src/core/auth/action-types.js